// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-header thead th[data-v-7ab6d871]{position:-webkit-sticky;position:sticky;top:0;background-color:#fff;z-index:10}.table[data-v-7ab6d871]{border-collapse:separate}.table thead th[data-v-7ab6d871]{border:0}.table td[data-v-7ab6d871],.table th[data-v-7ab6d871]{border-top:1px solid #dee2e6;border-left:0;border-right:0;border-bottom:0}", ""]);
// Exports
module.exports = exports;
